// Imports
  // React
  import { useState, useEffect } from 'react'
  import { Link } from 'react-router-dom';
  // Firebase
  import { getCombos } from "../firebase/FirebaseClient"
  // Components
  import BannerCard from './BannerCard'




//rafce

const BannerDestacados = ( ) => {
 

  // Get combos from Firebase
  const [combos, setCombos] = useState(JSON.parse(sessionStorage.getItem('storagedCombos')) || []);
  
  useEffect(() => {
    if(combos.length === 0){
      getCombos().then( data => {
        setCombos(data)
      })
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
    }
    else{
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
    }
  }, [])
  

  // Función para randomizar el array
  function shuffle() {
    var j, x, i;
    //Recorremos el array del final hacia delante
    for (i = combos.length - 1; i > 0; i--) {
      //Generamos una posicion comprendida entre los valores de nuestro array
      j = Math.floor(Math.random() * (i + 1));
      // Asignamos el valor de la posición actual a una variable
      x = combos[i];
      //Intercambiamos los valores de las dos posiciones
      combos[i] = combos[j];
      combos[j] = x;
    }
  }

  
  // Mostrar combos
  function listCombos(){
    // Set session storage
    sessionStorage.setItem('storagedCombos', JSON.stringify(combos))
    // Randomizar el array
    shuffle(combos)
    // Filtrar combos
    const twoCombos = combos.slice(0,2)
    // Listar combos
    return (
      <div className="item-list-container">
        {
          twoCombos.map( c =>
            <Link className="banner-card" to="combos" key={c.id}>
              <div className='banner-card-category'>
                <h3>Destacados</h3>
              </div>
              <BannerCard item={c} />
            </Link>
          )
        }
      </div>
    )
  }


	// Component
  return (
    <div className='main-items'>
      {
        combos.length
        ?         
        listCombos()
        :
        <div className='item-list-container'>
          <div className="loading">
            <span></span>
          </div>
        </div>
      }
    </div>
  )
  
}

export default BannerDestacados

